/**
 * @author Ariel
 * @description 培训中心场地列表页面配置
 * @Date 2020/5/27
 */
import React from 'react'
import { component_tool } from '@/tool'
const { WizLocationSelect } = component_tool
import { WizTableForm } from '../../common'
const trainCenterConfig = WizTableForm.Config.trainCenter()

//配置项
let componentName = 'trainSite'
const columns = (data) => {
  return [
    {
      name: 'id',
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "场地名称",
      name: "name",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "场地编号",
      name: "code",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "场地应用类型",
      name: "type",
      dict: [
        {code: 0, codeName: '教室'},
        {code: 1, codeName: '大门'},
        {code: 2, codeName: '餐厅'},
        {code: 3, codeName: '其他'}
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {},
    },
    {
      title: "培训中心",
      name: "trainCenterName",
      tableItem: {}
    },
    {
      title: "培训中心",
      name: "trainCenterId",
      searchItem:{
        type: "diy",
        // selectType: 'radio',
        diy: WizTableForm,
        ...trainCenterConfig,
      }
    },
    {
      title: "城市",
      name: "city",
      dataIndex: "city",
      searchItem: {
        type: 'diy',
        diy: WizLocationSelect,
        showSearch: true,
        optionType:'city'
      },
      tableItem: {},
    },
    {
      title: "地址",
      name: "address",
      dataIndex: "address",
      tableItem: {},
    },
    {
      title: "场地状态",
      name: "status",
      dict: [
        {code: 0, codeName: '正常'},
        {code: 1, codeName: '停止使用'},
        {code: 2, codeName: '维修中'}
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {},
    },
    // {
    //   title: "创建时间",
    //   name: "createTime",
    //   tableItem: {}
    // },
  ]
};

const templateConfig = (data) => {
  let { _btnFun } = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        searchBarProps: {
          buttonSort: ['add','equipmentManagement','export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { children: '新增', icon: 'plus', type: 'primary' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/site/trainSite/trainSiteDetailAdd'
                }
              }
            },
            {
              key: 'equipmentManagement',
              name: 'WizButton',
              params: {
                children: '设备管理',
                key: '_btn',
                type: 'default',
              },
              onClick: (e) => _btnFun && _btnFun(e),
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出场地信息', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export"
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter };
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['update','look'],
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: { children: '编辑'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/site/trainSite/trainSiteDetailUpd'
              }
            }
          },
          {
            key: 'look',
            custom: true,
            params: { children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/site/trainSite/look'
              }
            }
          }
        ]
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
